// PostHog loader stub (vendor snippet)
// prettier-ignore
!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="vu fu pu gu bu init Hu zu qu ju Gu Xa Bu Qu Du eh ih nh sh rh oh capture getExtension Uu cu hh calculateEventProperties uh register register_once register_for_session unregister unregister_for_session gh Nu dh getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync mh identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset yh shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty fh Xu createPersonProfile setInternalOrTestUser ph wu opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ju debug Ya Os getPageViewId captureTraceFeedback captureTraceMetric Ru".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

const {
  customer,
  product: pageProduct,
  pageview: pageviewProperties = {},
  ...liquidGlobals
} = JSON.parse(document.getElementById('analytics-globals')?.textContent || '{}')
const SESSION_STORAGE_KEY = 'analytics_session'
const EXPERIMENTS_STORAGE_KEY = 'analytics_experiments'
const PAGE_TYPE_STORAGE_KEY = 'analytics_page_type'
const PRODUCT_FORMS =
  'device-product-form, body-product-form, body-belt-product-form, body-stand-product-form, body-panel-product-form, subscription-product-form'
// Cart lines that aren't products the customer chose.
const UNTRACKED_HANDLES = ['shipping-protection']

// product_category / product_line by product handle. The sheet's enums are closed, so
// unlisted handles send no category or line. Keep in sync with the checkout pixel's copy.
const PRODUCT_TAXONOMY = {
  'hair/essential': [
    'laser-hair-growth-system-essential',
    'essential-bundle',
    'essential-best-seller-bundle',
    'essential-eye-mask-bundle',
    'essential-face-mask-bundle',
    'essential-neck-chest-mask-bundle',
  ],
  'hair/professional': [
    'laser-hair-growth-system-professional',
    'laser-hair-growth-system-professional-pre-rebrand',
    'pro-bundle',
    'pro-eye-mask-bundle',
    'pro-neck-chest-mask-bundle',
    'professional-best-seller-bundle',
    'professional-face-mask-bundle',
    'professional-face-mask-pro-bundle',
    'professional-trio',
    'irestore-duo-pro-sculpt-belt',
    'pro-apex-panel-hair-helmet-bundle',
  ],
  'hair/elite': [
    'laser-hair-growth-system-elite',
    'elite-bundle',
    'elite-best-seller-bundle',
    'elite-eye-mask-bundle',
    'elite-face-mask-bundle',
    'elite-face-mask-pro-bundle',
    'elite-neck-chest-mask-bundle',
    'elite-hair-body-bundle',
    'elite-apex-panel-hair-helmet-bundle',
    'irestore-duo-elite-apex-1500',
  ],
  'hair/revive': [
    'revive-growth-accelerator-kit',
    'revive-max-growth-kit',
    'revive-plus-growth-accelerator-kit',
    'revive-plus-max-growth-kit',
    'revive-growth-activator-serum',
    'revive-thickening-shampoo',
    'revive-thickening-conditioner',
    'revive-thickening-duo-shampoo-conditioner',
    'revive-brow-lash-duo',
    'revive-eyebrow-enhancing-serum',
    'revive-eyelash-enhancing-serum',
  ],
  hair: ['scalpstim-derma-roller', 'anti-thinning-conditioner'],
  'supplement/revive': ['revive-hair-growth-formula', 'revive-advanced-hair-growth-formula', 'revive-biotin-vitamin-gummies'],
  'skin/illumina': [
    'illumina-led-face-mask',
    'illumina-led-eye-mask',
    'illumina-led-neck-chest-mask',
    'illumina-led-duo',
    'illumina-led-trio',
    'illumina-led-eye-mask-duo',
    'illumina-youthful-eye-bundle',
  ],
  skin: [
    'laser-face-mask-pro',
    'laser-face-mask-pro-duo',
    'laser-led-trio-pro',
    'irestore-duo-face-mask-sculpt-belt',
    'advanced-retinol-serum',
    'am-pm-duo',
    'growth-factor-peptide-firming-cream',
    'vitamin-c-brightening-serum',
    'renew-anti-aging-eye-cream',
    'renew-anti-aging-face-serum',
    'renew-calming-facial-spray',
    'renew-hydrating-foam-cleanser',
    'renew-red-light-essentials-kit',
  ],
  'body/apex': [
    'apex-half-body-led-panel',
    'irestore-apex-pro-studio-bundle',
    'irestore-apex-pro-full-body-bundle',
    'irestore-apex-elite-studio-bundle',
    'irestore-apex-elite-full-body-bundle',
    'pro-apex-panel-face-mask-bundle',
    'elite-apex-panel-face-mask-bundle',
  ],
  'body/sculpt': ['sculpt-led-belt', 'sculpt-belt-duo'],
  'body/flex': ['flex-led-belt'],
  accessory: [
    '3-year-warranty-essential',
    '3-year-warranty-pro',
    '4-year-warranty-additional-2-years-ess',
    '4-year-warranty-additional-2-years-pro',
    '4-year-warranty-additional-2-years-elite',
    'laser-face-mask-pro-warranty',
    'sculpt-belt-warranty',
    'flex-belt-warranty',
    'illumina-eye-mask-warranty',
    'illumina-face-mask-warranty',
    'illumina-neck-chest-mask-warranty',
    'illumina-led-duo-warranty',
    'illumina-led-trio-warranty',
    'rechargeable-battery-pack',
    'rechargeable-battery-pack-for-irestore-laser-device-elite',
    'rechargeable-battery-pack-for-irestore-laser-device-professional-essential',
    'irestore-professional-soft-carry-case',
    'device-cleaning-solution',
    'illumina-glow-stand',
    'apex-visionguard-glasses',
    'apex-body-panel-stands-system',
    'sculpt-belt-universal-power-bank',
    'light-activated-mist',
  ],
}
const TAXONOMY_BY_HANDLE = Object.fromEntries(
  Object.entries(PRODUCT_TAXONOMY).flatMap(([key, handles]) => handles.map((handle) => [handle, key.split('/')]))
)

// ponytail: assumes the store currency is USD (100% of orders are); convert here if a non-USD market launches
const toUsd = (cents) => (cents == null ? undefined : cents / 100)
// Storage access itself throws when the browser blocks it, so look it up inside the try.
const readStorage = (storage, key) => {
  try {
    return JSON.parse(window[storage].getItem(key))
  } catch {
    return null
  }
}
const writeStorage = (storage, key, value) => {
  try {
    window[storage].setItem(key, JSON.stringify(value))
  } catch {}
}
const capture = (event, properties) => window.posthog.capture(event, properties)
const pageProductId = pageProduct && String(pageProduct.productId)

// The sheet's product property block. Prices are in cents, as Shopify returns them.
const getProductBlock = ({ productId, variantId, sku, title, handle, price, compareAtPrice }) => {
  const [category, line] = TAXONOMY_BY_HANDLE[handle] || []
  return {
    product_id: productId == null ? undefined : String(productId),
    variant_id: variantId == null ? undefined : String(variantId),
    sku: sku || undefined,
    product_title: title,
    product_category: category,
    product_line: line,
    price_usd: toUsd(price),
    compare_at_price_usd: compareAtPrice > price ? toUsd(compareAtPrice) : undefined,
    discount_pct: compareAtPrice > price ? Math.round((1 - price / compareAtPrice) * 100) : undefined,
    is_bundle: /bundle|duo|trio|kit/.test(handle || ''),
  }
}

const getCartItemBlock = (item) =>
  getProductBlock({
    productId: item.product_id,
    variantId: item.variant_id,
    sku: item.sku,
    title: item.product_title,
    handle: item.handle,
    price: item.price,
  })

const getCartBlock = (cart) =>
  cart && {
    cart_value_usd: toUsd(cart.total_price),
    line_item_count: cart.items.length,
    cart_product_categories: [...new Set(cart.items.map((item) => TAXONOMY_BY_HANDLE[item.handle]?.[0]).filter(Boolean))],
    discount_usd: toUsd(cart.total_discount),
    discount_code: cart.discount_codes?.filter((discount) => discount.applicable).map((discount) => discount.code).join(',') || undefined,
  }

const getConsentState = () => {
  const privacy = window.Shopify?.customerPrivacy
  if (!privacy) return undefined
  const analytics = privacy.analyticsProcessingAllowed()
  const marketing = privacy.marketingAllowed()
  if (analytics && marketing) return 'granted'
  return analytics || marketing ? 'partial' : 'denied'
}

// PostHog only keeps UTM params as session entry properties, so keep the ad IDs from the
// session's landing URL, keyed on PostHog's session ID.
const getSessionGlobals = (props) => {
  let session = readStorage('localStorage', SESSION_STORAGE_KEY) || {}

  if (props.$session_id && session.id !== props.$session_id) {
    const params = new URL(props.$current_url || location.href).searchParams
    session = {
      id: props.$session_id,
      campaign_id: params.get('utm_id') || undefined,
      ad_id: params.get('ad_id') || undefined,
    }
    writeStorage('localStorage', SESSION_STORAGE_KEY, session)
  }

  return { campaign_id: session.campaign_id, ad_id: session.ad_id }
}

// Intelligems loads async, so events fired before it's ready go without assignments.
const getExperimentAssignments = () => {
  try {
    const user = window.igData?.user
    if (!user) return []
    return user
      .getExperiments()
      .map(({ id, name }) => ({ id, name, variant: user.getTestGroup(id) }))
      .filter(({ variant }) => variant)
  } catch {
    return []
  }
}

const getExperimentVariants = () => {
  const assignments = getExperimentAssignments()
  return assignments.length ? Object.fromEntries(assignments.map(({ id, variant }) => [id, variant.id])) : undefined
}

// Global properties from the event plan's Properties tab. Acquisition and device values
// PostHog already records ($session_entry_*, $device_type, $viewport_width) aren't duplicated.
const getGlobals = (props) => ({
  ...liquidGlobals,
  ...getSessionGlobals(props),
  consent_state: getConsentState(),
  experiment_variants: getExperimentVariants(),
})

// Checkout can't read theme settings, so hand the sale name to the checkout pixel in a cookie.
document.cookie = `analytics_sale_name=${encodeURIComponent(liquidGlobals.sale_name || '')}; path=/; SameSite=Lax`

// product_viewed, collection_viewed and lp_viewed are PostHog's $pageview with these added.
const referrerPageType = readStorage('sessionStorage', PAGE_TYPE_STORAGE_KEY) || undefined
writeStorage('sessionStorage', PAGE_TYPE_STORAGE_KEY, liquidGlobals.page_type)

const pageviewExtras = {
  ...pageviewProperties,
  ...(pageProduct && {
    ...getProductBlock(pageProduct),
    inventory_state: pageProduct.inventoryState,
    is_subscription_offer_shown: pageProduct.isSubscriptionOfferShown,
  }),
  referrer_page_type: referrerPageType,
}

window.posthog.init('phc_9Y3HlpgzS7buqtDqpb1lB1x8Dg3e7eYF67SPMOIAhpX', {
  api_host: 'https://ap.irestorelaser.com', // your managed reverse proxy domain
  ui_host: 'https://us.posthog.com', // necessary because you're using a proxy, this way links will point back to PostHog properly
  defaults: '2026-05-30',
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  before_send: (event) => {
    if (!event) return event
    Object.assign(event.properties, getGlobals(event.properties))
    if (event.event === '$pageview') Object.assign(event.properties, pageviewExtras)
    return event
  },
})

// Logged-in customers. customer_state and lifetime_order_count are person properties, so PostHog
// attaches them to every event from this person. Email is the distinct ID so the same person
// matches across login, email capture and checkout.
if (customer?.email) window.posthog.identify(customer.email, customer)

// product_variant_selected: radio changes inside a product form. The form's own change handler
// runs first (it's closer to the input), so its hidden variant ID is already updated.
document.addEventListener('change', (event) => {
  const input = event.target
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return
  const form = input.closest(PRODUCT_FORMS)
  if (!form) return

  const variantId = form.querySelector('input[name="id"]')?.value || input.value || form.getAttribute('variant-id')
  const prices = pageProduct?.variantPrices || {}
  const basePrice = prices[pageProduct?.variantId]
  capture('product_variant_selected', {
    product_id: pageProductId,
    variant_id: variantId || undefined,
    variant_label: input.labels?.[0]?.innerText.trim().replace(/\s+/g, ' ') || input.value,
    option_name: input.name,
    price_delta_usd: prices[variantId] != null && basePrice != null ? toUsd(prices[variantId] - basePrice) : undefined,
  })
})

// add_to_cart and add_to_cart_failed: every add goes through /cart/add, so read the request and response there.
// The response has the full line (product data); the request has the quantity added.
const getAddedQuantities = (body) => {
  let payload = body
  if (body instanceof FormData) payload = { id: body.get('id'), quantity: body.get('quantity') }
  else if (typeof body === 'string') {
    try {
      payload = JSON.parse(body)
    } catch {
      return {}
    }
  }
  const items = payload?.items || [payload]
  return Object.fromEntries(items.filter((item) => item?.id).map((item) => [String(item.id), Number(item.quantity) || 1]))
}

const getAddLocation = () => {
  if (window.HybridCart?.isOpen) return 'cart_recs'
  if (liquidGlobals.page_type === 'pdp' || liquidGlobals.page_type === 'lp') return liquidGlobals.page_type
  return 'quick_add'
}

const trackAdd = async (response, body, addLocation) => {
  const quantities = getAddedQuantities(body)
  if (!response.ok) {
    // Shopify answers with { status, message, description }. One event per failed request; the
    // error doesn't say which line failed, so it carries the first line requested.
    const error = await response
      .clone()
      .json()
      .catch(() => ({}))
    const [variantId, quantity] = Object.entries(quantities)[0] || []
    capture('add_to_cart_failed', {
      failure_reason: error.description || error.message || undefined,
      error_status: response.status,
      variant_id: variantId,
      quantity,
      add_location: addLocation,
    })
    return
  }
  lastAddedAt = Date.now()
  const data = await response.clone().json()
  for (const item of data.items || [data]) {
    if (UNTRACKED_HANDLES.includes(item.handle)) continue
    capture('add_to_cart', {
      ...getCartItemBlock(item),
      quantity: quantities[String(item.variant_id)] || quantities[String(item.id)] || 1,
      add_location: addLocation,
    })
  }
}

// email_captured: Klaviyo forms, the theme's own forms that post straight to Klaviyo's subscriptions
// API, and Octane quizzes. Identify here so the anonymous browsing joins to the person.
const captureEmail = (rawEmail, formId, captureSource = 'klaviyo') => {
  const email = rawEmail?.trim().toLowerCase()
  // Don't switch an already-identified person (e.g. a logged-in customer) to a different email.
  if (email && window.posthog.get_property('$user_state') !== 'identified') {
    window.posthog.identify(email, { email }, { customer_state: 'prospect' })
  }
  capture('email_captured', { capture_source: captureSource, form_id: formId })
}

const trackKlaviyoSubscription = (body) => {
  const { data } = JSON.parse(body)
  captureEmail(data.attributes.profile.data.attributes.email, data.relationships.list.data.id)
}

// Hybrid Cart opens the drawer as soon as /cart/add finishes, before the response body is read
// here, so cart_viewed waits on this to keep add_to_cart first.
let pendingAddCapture
let lastAddedAt = 0

const originalFetch = window.fetch
window.fetch = (...args) => {
  const request = originalFetch(...args)
  try {
    const [resource, options] = args
    const url = resource instanceof Request ? resource.url : String(resource)
    if (url.includes('/cart/add')) {
      const addLocation = getAddLocation()
      pendingAddCapture = request.then((response) => trackAdd(response, options?.body, addLocation)).catch(() => {})
    } else if (url.includes('a.klaviyo.com/client/subscriptions')) {
      request
        .then((response) => {
          if (response.ok) trackKlaviyoSubscription(options.body)
        })
        .catch(() => {})
    }
  } catch {}
  return request
}

// cart_viewed (drawer) and cart_item_removed come from Hybrid Cart's state. It boots from a
// deferred loader, so wait for it rather than assuming it's there.
// ponytail: polls for ~10s, switch to a Hybrid Cart ready event if it ever dispatches one
const whenHybridCart = (callback, attempts = 40) => {
  if (window.HybridCart?.subscribe) callback(window.HybridCart)
  else if (attempts > 0) setTimeout(() => whenHybridCart(callback, attempts - 1), 250)
}

// Hybrid Cart rewrites line properties on quantity changes, which changes the line key, so lines
// are matched by variant and selling plan instead.
const getLineId = (item) => `${item.variant_id}:${item.selling_plan_allocation?.selling_plan?.id || ''}`
const getLines = (items = []) => {
  const lines = new Map()
  for (const item of items) {
    const line = lines.get(getLineId(item))
    lines.set(getLineId(item), { ...item, quantity: (line?.quantity || 0) + item.quantity })
  }
  return lines
}

whenHybridCart((hybridCart) => {
  // The drawer opens as soon as an add finishes, before Hybrid Cart refetches the cart, so wait
  // (up to 3s) for cart data newer than the add.
  let onCartUpdated
  const whenCartFresh = async () => {
    await pendingAddCapture
    if (hybridCart.lastUpdated >= lastAddedAt) return
    await new Promise((resolve) => {
      onCartUpdated = resolve
      setTimeout(resolve, 3000)
    })
  }
  hybridCart.subscribe(
    (cart) => cart.isOpen,
    (isOpen) => {
      if (!isOpen) return
      whenCartFresh().then(() => capture('cart_viewed', { ...getCartBlock(hybridCart.data), surface: 'drawer' }))
    }
  )

  // The store updates the cart in place, so watch lastUpdated and keep a snapshot of the lines.
  let previousLines
  hybridCart.subscribe(
    (cart) => cart.lastUpdated,
    (_, cart) => {
      const data = cart.data
      if (!data) return
      const lines = getLines(data.items)
      for (const [lineId, item] of previousLines || []) {
        if (lines.has(lineId) || UNTRACKED_HANDLES.includes(item.handle)) continue
        capture('cart_item_removed', {
          ...getCartItemBlock(item),
          quantity: item.quantity,
          cart_value_usd_after: toUsd(data.total_price),
        })
      }
      previousLines = lines
      onCartUpdated?.()
    }
  )
})

// cart_line_quantity_changed. Hybrid Cart dispatches before it sends the update, so its cart is
// still the before state. Lines are addressed by key or variant ID. Dropping to 0 is
// cart_item_removed.
document.addEventListener('hybrid-cart:lines-update', ({ detail }) => {
  if (detail?.action !== 'update') return
  const items = window.HybridCart?.items || []
  const linesBefore = getLines(items)
  const before = detail.lines
    .map(
      ({ id }) =>
        items.find((item) => item.key === String(id)) || items.find((item) => String(item.variant_id) === String(id))
    )
    .filter(Boolean)
    .map((item) => ({ lineId: getLineId(item), quantity: linesBefore.get(getLineId(item)).quantity }))
  detail.promise
    .then(({ cart }) => {
      const linesAfter = getLines(cart?.items)
      for (const { lineId, quantity } of before) {
        const item = linesAfter.get(lineId)
        if (!item || item.quantity === quantity || UNTRACKED_HANDLES.includes(item.handle)) continue
        capture('cart_line_quantity_changed', {
          ...getCartItemBlock(item),
          direction: item.quantity > quantity ? 'increase' : 'decrease',
          quantity_before: quantity,
          quantity_after: item.quantity,
          cart_value_usd_after: toUsd(cart.total_price),
        })
      }
    })
    .catch(() => {})
})

// discount_code_applied / discount_code_rejected. The update carries the whole code list, so the
// attempted codes are the ones not already applied; removals add nothing new. Shopify keeps a
// rejected code on the cart as applicable: false whether it doesn't exist or doesn't apply, so
// not_applicable covers both.
document.addEventListener('hybrid-cart:discount-update', ({ detail }) => {
  const applied = (window.HybridCart?.data?.discount_codes || [])
    .filter((discount) => discount.applicable)
    .map((discount) => discount.code.toLowerCase())
  const attempted = (detail?.discountCodes || [])
    .map(({ code }) => code)
    .filter((code) => !applied.includes(code.toLowerCase()))
  if (!attempted.length) return
  detail.promise
    .then(({ cart }) => {
      if (!cart) return
      for (const code of attempted) {
        const discount = cart.discount_codes?.find((cartCode) => cartCode.code.toLowerCase() === code.toLowerCase())
        if (discount?.applicable) {
          capture('discount_code_applied', {
            discount_code: code,
            discount_usd: toUsd(cart.total_discount),
            cart_value_usd_after: toUsd(cart.total_price),
          })
        } else {
          capture('discount_code_rejected', {
            discount_code: code,
            rejection_reason: discount ? 'not_applicable' : 'not_found',
          })
        }
      }
    })
    .catch(() => {})
})

// Klaviyo forms: popup_shown and popup_dismissed for popups and flyouts (embeds send embedOpen),
// email_captured and sms_captured once per form, lead_form_started on the first keystroke. Klaviyo can
// send submit again on later steps of a multi-step form, and stepSubmit on every step, so the counts
// come from the first event carrying each field.
const klaviyoForms = {}
const getKlaviyoForm = (formId) => (klaviyoForms[formId] ||= {})
window.addEventListener('klaviyoForms', (event) => {
  const { type, formId, metaData = {} } = event.detail || {}
  const form = getKlaviyoForm(formId)
  if (type === 'embedOpen') form.location = 'embed'
  if (type === 'open') {
    form.location = 'popup'
    form.openedAt = Date.now()
    capture('popup_shown', { popup_id: formId })
  }
  if (type === 'close' && form.openedAt && !form.submitted) {
    capture('popup_dismissed', { popup_id: formId, time_to_dismiss_ms: Date.now() - form.openedAt })
  }
  if (type !== 'submit' && type !== 'stepSubmit') return
  form.submitted = true
  if (metaData.$email && !form.email) {
    form.email = true
    captureEmail(metaData.$email, formId)
  }
  if (metaData.$phone_number && !form.sms) {
    form.sms = true
    capture('sms_captured', { capture_source: 'klaviyo', form_id: formId, is_email_also_captured: !!form.email })
  }
})

// Klaviyo's renderer tags each form data-testid="klaviyo-form-{formId}" (its Render bundle, Oct 2026).
// It's a test hook with no documented contract, so lead_form_started stops if Klaviyo renames it.
document.addEventListener('input', ({ target }) => {
  const formId = target.closest?.('form[data-testid^="klaviyo-form-"]')?.dataset.testid.slice('klaviyo-form-'.length)
  if (!formId) return
  const form = getKlaviyoForm(formId)
  if (form.started) return
  form.started = true
  capture('lead_form_started', { form_id: formId, form_location: form.location })
})

// Octane quizzes. quiz_result_cta_clicked is autocapture on [data-quiz-cta] / [data-result-cta].
let quizStartedAt
// Octane swaps the .octane-ai-quiz class for .octane-ai-quiz-rendered once it loads, so match the attribute.
const getQuizId = () => document.querySelector('[data-quiz-id]')?.dataset.quizId
const startQuiz = () => {
  if (quizStartedAt) return
  quizStartedAt = Date.now()
  capture('quiz_started', { quiz_id: getQuizId() })
}
document.addEventListener('octane.quiz.rendered', startQuiz)
document.addEventListener('octane.quiz.questionLoaded', startQuiz)
// quiz_question_answered leaves the answer out for privacy. Re-answering after going back doesn't count.
const answeredQuestions = new Set()
document.addEventListener('octane.quiz.questionAnswered', ({ detail }) => {
  // Octane also sends this for explainer screens and skipped questions.
  const hasAnswer = detail?.question_type !== 'explainer' && [detail?.question_value].flat().some(Boolean)
  if (!hasAnswer || !detail.question_id || answeredQuestions.has(detail.question_id)) return
  answeredQuestions.add(detail.question_id)
  capture('quiz_question_answered', {
    quiz_id: getQuizId(),
    question_index: answeredQuestions.size,
    question_id: detail.question_id,
  })
  // The address goes to Octane's servers, so neither Klaviyo hook above sees it.
  if (detail.question_type === 'email') captureEmail(detail.question_value, getQuizId(), 'quiz')
})
document.addEventListener('octane.quiz.completed', (event) => {
  // The quiz section's own completed handler (registered first) has already pointed the
  // result CTA at the recommended product.
  const resultUrl = document.querySelector('[data-quiz-cta], [data-result-cta]')?.getAttribute('href')
  capture('quiz_completed', {
    quiz_id: getQuizId(),
    question_count: Object.keys(event.detail?.answers || {}).length,
    completion_time_ms: quizStartedAt ? Date.now() - quizStartedAt : undefined,
    recommended_product_handle: resultUrl?.match(/\/products\/([^/?#]+)/)?.[1],
  })
})

// support_widget_opened: Gorgias chat loads late and announces itself, as the sticky nav sections
// also rely on.
const trackSupportWidget = () =>
  window.GorgiasChat?.on?.('widget:opened', () => capture('support_widget_opened', { product_id: pageProductId }))
if (window.GorgiasChat)
  Promise.resolve()
    .then(() => window.GorgiasChat.init())
    .then(trackSupportWidget)
    .catch(() => {})
else window.addEventListener('gorgias-widget-loaded', trackSupportWidget, { once: true })

// section_viewed: once per template section, when half of it has been on screen, or half the
// screen for sections taller than it. Section groups (header, footer) render outside main.
const SECTION_VIEW_PAGE_TYPES = ['pdp', 'lp', 'category', 'home', 'collection']
// JSON template wrappers are shopify-section-template--{id}__{key}; static sections have no key.
const getSectionId = (section) => section?.id.replace(/^shopify-section-(.*__)?/, '')
if (SECTION_VIEW_PAGE_TYPES.includes(liquidGlobals.page_type)) {
  const sections = [...document.querySelectorAll('#MainContent > .shopify-section')]
  const sectionObserver = new IntersectionObserver(
    (entries) => {
      for (const { target, isIntersecting, boundingClientRect, intersectionRect } of entries) {
        const { height } = boundingClientRect
        if (!isIntersecting || !height || intersectionRect.height < Math.min(height, window.innerHeight) / 2) continue
        sectionObserver.unobserve(target)
        capture('section_viewed', {
          section_id: getSectionId(target),
          section_index: sections.indexOf(target) + 1,
          section_name:
            target.querySelector('h1, h2, h3')?.textContent.trim().replace(/\s+/g, ' ').slice(0, 80) || undefined,
          product_id: pageProductId,
          lp_handle: pageviewProperties.lp_handle,
        })
      }
    },
    // A section 10 screens tall qualifies at a 5% ratio, so the steps need to be fine.
    { threshold: Array.from({ length: 101 }, (_, i) => i / 100) }
  )
  sections.forEach((section) => sectionObserver.observe(section))
}

// sticky_atc_shown: the pdp-sticky-nav and bundle-sticky-atc bars show by setting aria-hidden="false"
// (site-header:sticky-nav-active only means one was mounted). Each bar is display: none at the
// breakpoints it doesn't serve, so a bar with no box isn't shown.
if (liquidGlobals.page_type === 'pdp') {
  const isShown = (bar) => bar.getAttribute('aria-hidden') === 'false' && bar.getClientRects().length > 0
  const stickyObserver = new MutationObserver((records) => {
    if (!records.some(({ target }) => isShown(target))) return
    stickyObserver.disconnect()
    const scrollable = document.documentElement.scrollHeight - window.innerHeight
    capture('sticky_atc_shown', {
      product_id: pageProductId,
      scroll_depth_pct: scrollable > 0 ? Math.round((window.scrollY / scrollable) * 100) : undefined,
    })
  })
  document
    .querySelectorAll('#pdp-sticky-nav-overlay, #pdp-mobile-cta, #bundle-sticky-atc, #bundle-sticky-atc-mobile')
    .forEach((bar) => stickyObserver.observe(bar, { attributeFilter: ['aria-hidden'] }))
}

// product_media_viewed: each slide change in the main PDP gallery. Splide's moved doesn't say why the
// gallery moved, so the input comes from what the visitor last touched. A move with no recent input
// is the site's own, such as a variant change. A drag that snaps back also fires moved, with a stale
// previous index, so the last index is kept here.
const MEDIA_INPUT_WINDOW_MS = 1500
document.addEventListener('product-media:ready', ({ detail: { main, thumbs } }) => {
  let input
  const setInput = (method) => (input = { method, at: Date.now() })
  const onClick = ({ target }) => {
    if (target.closest('.splide__arrow')) setInput('arrow')
    else if (target.closest('.splide__pagination')) setInput('dot')
    else if (thumbs?.root.contains(target)) setInput('thumbnail')
  }
  for (const splide of [main, thumbs]) {
    splide?.root.addEventListener('click', onClick, true)
    splide?.on('dragged', () => setInput('swipe'))
  }
  let lastIndex = main.index
  main.on('moved', (index) => {
    const inputMethod = Date.now() - input?.at < MEDIA_INPUT_WINDOW_MS ? input.method : undefined
    const isSameSlide = index === lastIndex
    input = undefined
    lastIndex = index
    if (!inputMethod || isSameSlide) return
    const { mediaId, mediaType } = main.Components.Slides.getAt(index)?.slide.dataset ?? {}
    capture('product_media_viewed', {
      product_id: main.root.closest('[data-product-id]')?.dataset.productId || pageProductId,
      media_id: mediaId,
      media_type: mediaType,
      media_index: index + 1,
      input_method: inputMethod,
    })
  })
})

// product_video_played: once per video per play_type (and source, since a video modal reuses one
// element). lazy-video.js and sliders play videos as they come into view, so a play is manual only
// right after a tap, click or key on the video or a play control. Media events don't bubble.
const PLAY_CONTROLS =
  '[data-video-url], [data-pdp-info-modal-open], [data-video-play-button], [data-inline-video-play], [id^="video-play-"], [aria-label^="Play"]'
const MANUAL_PLAY_WINDOW_MS = 1500
let lastGesture = { time: 0 }
const recordGesture = ({ target }) => (lastGesture = { target, time: Date.now() })
for (const type of ['pointerdown', 'click', 'keydown']) document.addEventListener(type, recordGesture, true)
const playedVideos = new WeakMap()
document.addEventListener(
  'play',
  ({ target: video }) => {
    if (!(video instanceof HTMLVideoElement)) return
    const { target, time } = lastGesture
    const isManual =
      Date.now() - time < MANUAL_PLAY_WINDOW_MS && (target === video || !!target.closest?.(PLAY_CONTROLS))
    const source = [...video.querySelectorAll('source')].at(-1)?.getAttribute('src') || video.currentSrc
    const videoId = video.getAttribute('alt') || source?.split('?')[0].split('/').pop() || undefined
    const playType = isManual ? 'manual' : 'autoplay'
    const played = playedVideos.get(video) || new Set()
    const playKey = `${playType}:${videoId}`
    if (played.has(playKey)) return
    playedVideos.set(video, played.add(playKey))
    capture('product_video_played', {
      video_id: videoId,
      section_id: getSectionId(video.closest('.shopify-section')),
      product_id: pageProductId,
      play_type: playType,
    })
  },
  true
)

// experiment_exposed: once per Intelligems assignment on this device.
const trackExperimentExposures = () => {
  const seen = readStorage('localStorage', EXPERIMENTS_STORAGE_KEY) || {}
  let changed = false
  for (const { id, name, variant } of getExperimentAssignments()) {
    if (seen[id] === variant.id) continue
    seen[id] = variant.id
    changed = true
    capture('experiment_exposed', {
      experiment_id: id,
      experiment_name: name,
      variant_id: variant.id,
      variant_name: variant.name,
      source: 'intelligems',
    })
  }
  if (changed) writeStorage('localStorage', EXPERIMENTS_STORAGE_KEY, seen)

  // Checkout can't read Intelligems either, so hand assignments to the checkout pixel in a cookie.
  // This sends everything seen because Intelligems only reports experiments targeting the current
  // page, while assignments persist across pages.
  if (Object.keys(seen).length) {
    document.cookie = `analytics_experiment_variants=${encodeURIComponent(JSON.stringify(seen))}; path=/; SameSite=Lax`
  }
}
window.addEventListener('ig:ready', trackExperimentExposures)
trackExperimentExposures()
